import { render, staticRenderFns } from "./add_subcategories_marketplace_page.vue?vue&type=template&id=34a53d06"
import script from "./add_subcategories_marketplace_page.vue?vue&type=script&lang=js"
export * from "./add_subcategories_marketplace_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports